import { apiAction, API_SUCCESS } from "../dux/api";
import {
  FETCH_BOOKING_SETTING,
  UPDATE_BOOKING_SETTING,
  UPSERT_PRICING_CONFIG,
  setBookingSetting,
} from "../dux/bookingSetting";

import { apiCallComplete } from "../dux/apiStatus";
import { openSnackbar } from "../dux/snackbar";
import { API_ERROR } from "../dux/api";
import {
  getFetchBookingSettingUrl,
  getUpdateBookingSettingUrl,
  getUpsertPricingUrl,
} from "../helpers/apiEndPoints";

const bookingSetting = () => (next) => (action) => {
  next(action);

  if (action.type === UPDATE_BOOKING_SETTING) {
    next(
      apiAction({
        url: getUpdateBookingSettingUrl(
          action.payload.sport,
          action.payload.location
        ),
        method: "PUT",
        feature: UPDATE_BOOKING_SETTING,
        data: {
          json: action.payload.json ?? {},
        },
      })
    );
  }

  if (action.type === UPSERT_PRICING_CONFIG) {
    next(
      apiAction({
        url: getUpsertPricingUrl(),
        method: "POST",
        feature: UPSERT_PRICING_CONFIG,
        data: action.payload.json,
      })
    );
  }

  if (action.type === FETCH_BOOKING_SETTING) {
    const { sport, location, includeSpecialOffers = false } = action.payload;
    next(
      apiAction({
        url: getFetchBookingSettingUrl(sport, location, includeSpecialOffers),
        feature: FETCH_BOOKING_SETTING,
      })
    );
  }
  if (action.type === `${FETCH_BOOKING_SETTING} ${API_SUCCESS}`) {
    // Handle the new pricing config response structure
    const response = action.payload?.response || action.payload;

    // The new API response has NORMAL and HOLIDAY directly at the root level
    // We use the response directly as it already has the correct structure
    next(
      setBookingSetting({
        bookingSetting: response,
      })
    );
  }
  if (action.type === `${UPDATE_BOOKING_SETTING} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "bookingSetting" }));
    next(
      openSnackbar({
        message: "Setting has been updated successfully.",
      })
    );
  }

  if (action.type === `${UPDATE_BOOKING_SETTING} ${API_ERROR}`) {
    next(apiCallComplete({ api: "bookingSetting" }));
  }

  if (action.type === `${UPSERT_PRICING_CONFIG} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "upsertPricingConfig" }));
    next(
      openSnackbar({
        message: "Pricing configuration has been saved successfully.",
      })
    );
  }

  if (action.type === `${UPSERT_PRICING_CONFIG} ${API_ERROR}`) {
    next(apiCallComplete({ api: "upsertPricingConfig" }));
  }
};

export default bookingSetting;
